import { ShieldX } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

/**
 * Rejected-user landing page. The admin-api callback redirects here with the
 * email as a query parameter; we render it from `location.search` at runtime
 * so the email is never baked into the static SPA bundle.
 */
export function NotAuthorized() {
  const email = new URLSearchParams(window.location.search).get('email');
  return (
    <main className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center gap-3 py-12 text-center">
          <div className="rounded-full bg-slate-100 p-3 text-slate-500">
            <ShieldX className="h-6 w-6" />
          </div>
          <h1 className="text-xl font-semibold tracking-tight text-slate-900">
            Not authorized
          </h1>
          <p className="text-sm text-slate-600">
            {email ? (
              <>{email} is not on the allowlist.</>
            ) : (
              <>Your email is not on the allowlist.</>
            )}
          </p>
        </CardContent>
      </Card>
    </main>
  );
}
